export function getCurrencyValue(
  numberValue = 0,
  locale,
  currencyCode = 'AUD',
) {
  const stringCurrencyValue = numberValue.toLocaleString(locale || [], {
    style: 'currency',
    currencyDisplay: 'code',
    useGrouping: false,
    currency: currencyCode,
  });

  return Number(stringCurrencyValue.replace(currencyCode, ''));
}

export function formatCurrency(value, currency, opts = {}) {
  const { maximumFractionDigits } = opts;
  const formatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currencyDisplay: 'code',
    currency,
    useGrouping: false,
    maximumFractionDigits,
  });

  const formattedValue = formatter.format(value);
  return Number(formattedValue.replace(currency, ''));
}
